import React from 'react'
import DatePicker from 'react-datepicker'
import DateInput from './date-input'

export default function Activities({selectedDate, onDateChange}) {
  const today = selectedDate == moment().format('MM/DD/YYYY')

  return <div className='date-block'>
    <DatePicker
      customInput={<DateInput />}
      onChange={(date) => onDateChange((date || moment()).format('MM/DD/YYYY'))}
      selected={moment(new Date(selectedDate))}
    />
    { !today && 
      <a className='btn btn-default clickable' onClick={() => onDateChange(moment().format('MM/DD/YYYY'))}>Today</a>
    }
  </div>
}
